/**
 * IMPORTS
 */

import { Badge } from "@components/badge/badge";
import { TableCell, TableRow } from "@components/table/table";

import { handleLimitTextdisplayByAmount } from "@/utils/text-limit";

export function ManagerCreditsMainTable({ credits }: { credits: any }) {
  return (
    <TableRow className="cursor-pointer">
      <TableCell className="font-medium">
        {handleLimitTextdisplayByAmount({
          text: credits.produto,
          limit: 24,
        })}
      </TableCell>

      <TableCell className="font-medium">
        <Badge className={"bg-green-500"}>
          {handleLimitTextdisplayByAmount({
            text: credits.saldo,
            limit: 24,
          })}
        </Badge>
      </TableCell>

      <TableCell className="font-medium">
        {handleLimitTextdisplayByAmount({
          text: credits.responsavel,
          limit: 24,
        })}
      </TableCell>

      <TableCell className="font-medium">
        {handleLimitTextdisplayByAmount({
          text: credits.data,
          limit: 24,
        })}
      </TableCell>

      {/* Ações */}
    </TableRow>
  );
}
